import { Service } from './service.model';

export interface InstallationDisposal {
  disposal: Service;
  installation: Service;
  isDisposalAvailable: boolean;
  isDisposalSelected: boolean;
  isInstallationAvailable: boolean;
  isInstallationSelected: boolean;
}

export interface UpfrontPaymentSummary {
  make: string;
  model: string;
  applianceCategory: string;
  upgradeFee: number;
  isProtectionSelected: boolean;
  replacementCost: number;
  monthlyPayment: number;
  isInstallationSelected: boolean;
  isInstallationAvailable: boolean;
  installation: Service;
  isDisposalSelected: boolean;
  isDisposalAvailable: boolean;
  disposal: Service;
  isDeliveryAvailable: boolean;
  isDeliverySelected: boolean;
  delivery;
  outstandingMonthlyPayments: number;
  outstandingPlanAmount: number;
  jobReferenceNumber: string;
  offerType: string;
}

export const UpfrontPaymentSummary = undefined;
